

export const AUTH_TOKEN ="Auth@Ria@2026"

export const BASE_URL ="https://app.riaug.org";
// export const BASE_URL ="http://localhost:8000";



// export const headers = {'Authorization': `Bearer ${AUTH_TOKEN}`};
export const headers = {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
    'Authorization': `Bearer ${AUTH_TOKEN}`
    // 'Content-Type': 'application/json',

};

export const fileUploadHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'multipart/form-data',
};

